/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// prevent scroll when open popup
const preventScroll = () => {
	const body = document.body;
	const scrollY = document.documentElement.style.getPropertyValue('--scroll-y');
	body.style.position = 'fixed';
	body.style.top = `-${scrollY}`;
	body.style.width = '100%';
};

// cancel prevent scroll when open popup
const cancelPreventScroll = () => {
	const body = document.body;
	const scrollY = body.style.top;
	body.style.position = '';
	body.style.top = '';
	window.scrollTo(0, parseInt(scrollY || '0') * -1);
};

// set position default when
const setPositionBody = () => {
	window.addEventListener('scroll', () => {
		document.documentElement.style.setProperty(
			'--scroll-y',
			`${window.scrollY}px`
		);
	});
};
setPositionBody();

// scroll to top
const moveToTop = () => {
	window.scrollTo({ top: 0, behavior: 'smooth' });
};

const scrollTo = (element) => {
	const headerHeight = document.getElementsByClassName(
		'shopify-section__header'
	)[0].offsetHeight;
	const offsetHeightEle = element.getBoundingClientRect().top + window.scrollY;

	// 10 is space from element to header, improve UI
	window.scroll({
		top: offsetHeightEle - headerHeight - 10,
		behavior: 'smooth'
	});
};

const showCommonModal = (elementId) => {
	const element = document.getElementById(elementId);
	element.setAttribute('aria-hidden', 'false');
	preventScroll();

	const btnToTop = document.getElementById('btn-to-top');
	btnToTop.classList.add('hide');
};

const hideModal = () => {
	const modalRegister = document.querySelector('[aria-hidden="false"]');

	modalRegister.setAttribute('aria-hidden', 'true');
	cancelPreventScroll();

	const btnToTop = document.getElementById('btn-to-top');
	btnToTop.classList.remove('hide');
};

const showLoading = () => {
	const loading = document.getElementById('loading-circle');
	loading.style.display = 'block';
	preventScroll();

	const btnToTop = document.getElementById('btn-to-top');
	btnToTop.classList.add('hide');
};

const hideLoading = () => {
	const loading = document.getElementById('loading-circle');
	loading.style.display = 'none';
	cancelPreventScroll();
};

const showError = (text, isNeedHideModal = true) => {
	if (isNeedHideModal) {
		hideLoading();
	}
	setTimeout(() => {
		alert(text);
	}, 300);
};

const toPriceFormat = (amount) => {
	if (!amount) return '';
	return Math.round(amount).toLocaleString('ja-JP');
};

/* header serchbar control */
/*検索候補非表示コメントアウト
const headerSearchBar = document.querySelector('.pr_search-bar');
const headerSearchBarLink = document.querySelector('.pr_search-bar .nav-bar__link');
const headerSearchBarWrapper = document.querySelector('.pr_header__search-bar-wrapper');
const headerSearchBarInput = document.querySelector('.pr_search-bar .search-bar__input[name="q"]');

headerSearchBar.addEventListener('click', function(event) {
  document.body.classList.add('visible-searchbar');    
  setTimeout(function() {
	document.querySelector('.pr_search-bar .search-bar__input[name="q"]').focus();
  }, 50);  
});

document.addEventListener('click', function(event) {
  if (headerSearchBar && headerSearchBar.classList.contains('is-dropdown-open') && document.body.classList.contains('visible-searchbar') && !event.target.closest('.pr_search-bar')) {    
	headerSearchBar.classList.remove('is-dropdown-open');
	headerSearchBarLink.setAttribute('aria-expanded', 'false');
	headerSearchBarWrapper.setAttribute('aria-hidden', 'true');
	document.body.classList.remove('visible-searchbar');
  }
}); */

// 
function initStep() {
	const range = document.querySelectorAll('input[type="range"]');
	if (range != null) {
		range.forEach((elm) => {
			elm.setAttribute('step', 1000);
		});
	}
}
window.addEventListener('load', () => {
	if (document.querySelector('.price-range') != null) {
		initStep();
		setInterval(initStep, 500);
	}
});

// 

// 
function initDataToCF(column_key, val) {
	console.log('column_key:' + column_key);
	console.log('val:' + val);
	CF.ready(function () {
		var $myForm = document.querySelector('form[data-cf-form]');
		var cfForm = $myForm.cfForm;
		cfForm.setFieldValue(column_key, val)
	});
}

document.addEventListener('DOMContentLoaded', () => {
	const customer_forms = document.querySelectorAll('[id="create_customer"], [data-cf-edit-account="true"], [data-section-type="account"] form');
	if (customer_forms != null) {
		customer_forms.forEach((customer_form) => {
			customer_form.classList.add('h-adr');
			const country_name = document.createElement('span');
			country_name.style.display = 'none';
			country_name.classList.add('p-country-name');
			country_name.textContent = 'Japan';
			customer_form.insertBefore(country_name, customer_form.firstElementChild);
			const events = ['click', 'keydown'];
			let postal_code_flag = true;
			let region_flag = true;
			let address1_flag = true;
			let address2_flag = true;
			let yubinbango_flag = true;

			for (let i in events) {
				customer_form.addEventListener(events[i], () => {
					// init postal code
					const postal_code = customer_form.querySelector('.ci-postal-code');
					if (postal_code != null && postal_code_flag) {
						const input = postal_code.querySelector('input');
						input.classList.add('p-postal-code');
						if (customer_form.getAttribute('data-cf-form')) {
							input.addEventListener('input', () => {
								const inputs = customer_form.querySelectorAll('[data-cf-column-key="address_province"], [data-cf-column-key="address"], [data-cf-column-key="address2"]');
								inputs.forEach((elm) => {
									setTimeout(() => {
										if (elm.value.length > 0) {
											initDataToCF(elm.getAttribute('data-cf-column-key'), elm.value);
										}
									}, 500);
								});
							});
						}
						postal_code_flag = false;
					}
					// init region
					const region = customer_form.querySelector('.ci-region');
					const region_select = region.querySelector('select');
					if (region != null && region_flag) {
						const input = document.createElement('input');
						input.classList.add('p-region');
						input.style.display = 'none';
						region.appendChild(input);
						region_flag = false;
					}
					// change region select
					setTimeout(() => {
						const region_input = customer_form.querySelector('.p-region');
						const options = region_select.querySelectorAll('option');
						options.forEach((op) => {
							if (op.value == region_input.value || op.textContent == region_input.value) {
								region_select.value = op.value;
							}
						});
					}, 500);

					// init locality
					const locality = customer_form.querySelector('.ci-address1');
					if (locality != null && address1_flag) {
						const input = locality.querySelector('input');
						input.classList.add('p-locality');
						address1_flag = false;
					}
					// init street address
					const street_address = customer_form.querySelector('.ci-address2');
					if (street_address != null && address2_flag) {
						const input = street_address.querySelector('input');
						input.classList.add('p-street-address');
						input.classList.add('p-extended-address');
						address2_flag = false;
					}
					// init yubibango.js
					if (postal_code_flag == false && region_flag == false && address1_flag == false && address2_flag == false && yubinbango_flag) {
						new YubinBango.MicroformatDom();
						yubinbango_flag = false;
					}
				});
			}
		});
	}
});
// 

class wrappingModal {
	modals = [...document.querySelectorAll('.wrapping-modal--container')];

	constructor() {
		for (const modal of this.modals) {
			const button = modal.previousElementSibling;
			button.addEventListener('click', () => {
				modal.classList.toggle('active');
			});

			for (const close of [...modal.querySelectorAll('.close')]) {
				close.addEventListener('click', e => {
					e.preventDefault();
					modal.classList.toggle('active');
				});
			}

			const submit = modal.querySelector('.wrapping-modal--inner button');
			submit.addEventListener('click', async () => {
				submit.disabled = true;

				const { key } = submit.dataset;
				const { value } = modal.querySelector(`[name*="${key}"]:checked`);

				const properties = {};
				const json = JSON.parse(submit.nextElementSibling.innerHTML) || [];
				if (json.length > 0) {
					for (const [k, v] of json) {
						properties[k] = v;
					}
				}

				properties['ラッピング'] = value;

				try {
					const res = await (await fetch('/cart/change.js', {
						method: 'post',
						headers: {
							'Content-Type': 'application/json',
							'Accept': 'application/json'
						},
						body: JSON.stringify({ id: key, properties })
					})).json();

					location.reload();
				} catch (err) {
					console.error(err);
					alert('商品の更新に失敗しました。');
					modal.classList.toggle('active');
				}
			});
		}
	};
};

class SortKana {
	items = [];
	orders = [
		{ code: 'ア', min: 12450, max: 12458 },
		{ code: 'カ', min: 12459, max: 12467 },
		{ code: 'サ', min: 12469, max: 12477 },
		{ code: 'タ', min: 12479, max: 12488 },
		{ code: 'ナ', min: 12490, max: 12494 },
		{ code: 'ハ', min: 12495, max: 12507 },
		{ code: 'マ', min: 12510, max: 12514 },
		{ code: 'ヤ', min: 12516, max: 12520 },
		{ code: 'ラ', min: 12521, max: 12525 },
		{ code: 'ワ', min: 12527, max: 12531 },
		{ code: 'その他', min: 99999, max: 99999 }
	];

	constructor(stones) {
		this.stones = [...stones];

		for (const e of this.stones) {
			const code = e.dataset?.code !== undefined ? e.dataset.code : e.textContent;
			if (code.includes('その他')) {
				e.dataset.code = 99999;
				continue;
			}

			e.dataset.code = this.pickKana(e.dataset.code);

			// const match = e.textContent.match(/[（(](.+?)[）)]/);
			// e.dataset.code = (match ? match[1] : e.dataset.code)[0];
			e.dataset.code = e.dataset.code.replace(/[\u3041-\u3096]/g, c =>
				String.fromCodePoint(c.charCodeAt(0) + 0x60)
			);
			e.dataset.code = e.dataset.code.normalize('NFD').replace(/[\u3099\u309A]/g, '');
			e.dataset.code = e.dataset.code.codePointAt(0);
		}

		this.items = [...this.stones].sort((a, b) => Number(a.dataset.code) - Number(b.dataset.code));
	};

	pickKana(str) {
		const katakanaMatch = str.match(/[ァ-ンヴー]/);
		if (katakanaMatch) {
			return katakanaMatch[0];
		}

		const hiraganaMatch = str.match(/[ぁ-んゔー]/);
		if (hiraganaMatch) {
			return hiraganaMatch[0];
		}

		return str[0];
	};
};

class toggleAccordionMenu {
	menus = document.querySelectorAll('.mobile-menu__nav-list-toggle');

	constructor() {
		for (const i in [...this.menus]) {
			const menu = this.menus[i];
			const parent = menu.closest('.mega-menu__column');
			const container = parent.querySelector('.mobile-menu__nav-collapsible');
			if (container !== null) {
				parent.style.cssText = `--container-height: ${container.scrollHeight}px; --container-offset: ${i % 3};`;
			}

			menu.addEventListener('click', e => {
				if (menu.ariaExpanded === 'true') {
					menu.ariaExpanded = false;
					return;
				}
				for (const m of [...this.menus]) {
					m.ariaExpanded = false;
				}
				menu.ariaExpanded = true;
			});
		}
	};
};

class toggleGlobalMenu {
	buttons = document.querySelectorAll('.nav-bar .nav-bar__link');

	constructor() {
		for (const button of [...this.buttons]) {
			const parent = button.closest('li');
			const container = parent.querySelector('[data-type="menu"]');
			if (container === null) {
				continue;
			}

			button.addEventListener('click', e => {
				if (button.nodeName == 'A') {
					return;
				}

				e.preventDefault();
				if (button.closest('ul').classList.contains('nav-dropdown--glued')) {
					button.closest('ul').classList.remove('nav-dropdown--glued');
					button.closest('li').classList.remove('is-dropdown-open');
					button.ariaExpanded = false;
					container.ariaHidden = true;
					return;
				}

				button.closest('ul').classList.add('nav-dropdown--glued');
				button.closest('li').classList.add('is-dropdown-open');
				button.ariaExpanded = true;
				container.ariaHidden = false;
			});
		}
	};
};

class toggleHamburgerMenu {
	parent = document.querySelector('header .hamburger');

	constructor() {
		if (this.parent === null) {
			return;
		}

		this.button = this.parent.querySelector('.header__mobile-nav-toggle');
		this.drawer = this.parent.querySelector('.mobile-menu');

		this.button.addEventListener('click', () => {
			this.toggleAttr(this.button.ariaExpanded === 'false');
		});

		this.drawer.querySelector('.close').addEventListener('click', () => {
			this.toggleAttr();
		});

		this.setOffset();
		window.addEventListener('scroll', () => this.setOffset());
	};

	toggleAttr(boolean = false) {
		this.button.ariaExpanded = boolean;
		this.drawer.ariaHidden = !boolean;
	};

	setOffset() {
		const bars = [], header = [];
		for (const e of [...document.querySelectorAll('.shopify-section-group-header-group')]) {
			if (e.classList.contains('shopify-section__header')) {
				header.push(e);
				continue;
			}
			bars.push(e);
		}

		let announce = bars.reduce((sum, { offsetHeight }) => sum + offsetHeight, 0);
		if (window.scrollY > announce) {
			announce = 0;
		}

		const nav = document.querySelector('.nav-bar');
		if (nav !== null && document.body.offsetWidth > 1000) {
			announce -= nav.offsetHeight;
		}

		this.drawer.style.cssText = `--header: ${header[0].offsetHeight + announce}px;`;
	};
};

class searchBox {
	inputs = document.querySelectorAll('[name="q"]');

	constructor() {
		for (const input of [...this.inputs]) {
			const duplicate = this.duplicate(input);
			input.after(duplicate);
			input.type = 'hidden';

			const parent = input.closest('form');
			duplicate.addEventListener('change', () => this.setQuary(parent, input, duplicate));
			duplicate.addEventListener('input', () => this.setQuary(parent, input, duplicate));

			for (const e of [...parent.querySelectorAll('[type="radio"]')]) {
				e.addEventListener('change', () => this.setQuary(parent, input, duplicate));
			}
		}
	};

	duplicate({ className, placeholder }) {
		return Object.assign(
			document.createElement('input'),
			{
				autocomplete: 'off',
				autocorrect: 'off',
				className,
				placeholder,
				type: 'text'
			}
		);
	};

	setQuary(parent, input, duplicate) {
		if (parent.querySelector('[type="radio"]:checked').value === 'article,page') {
			input.value = duplicate.value;
			return;
		}
		const array = [];
		for (const str of duplicate.value.split(/ |　/)) {
			array.push(str);
		}
		const unique = [...new Set(array.filter(Boolean))];
		const query = [];
		for (const key of ['title:', 'body:']) {
			query.push(key + unique.join('　'));
		}
		for (const value of unique) {
			query.push('tag:検索_' + value);
		}
		input.value = query.join(' OR ');
	};
};

document.addEventListener('DOMContentLoaded', () => {
	window.wrappingModal = new wrappingModal;
	window.toggleAccordionMenu = new toggleAccordionMenu;
	window.toggleGlobalMenu = new toggleGlobalMenu;
	window.toggleHamburgerMenu = new toggleHamburgerMenu;
	window.searchBox = new searchBox;
});

class cartEvent {
	disableds = '土,日'.split(',');
	disable_dates = '2025-12-29,2025-12-30,2025-12-31,2026-01-01,2026-01-02,2026-01-05,2026-01-12,2026-01-29,2026-01-30,2026-02-02,2026-02-11,2026-02-23,2026-03-20,2026-04-29,2026-05-04,2026-05-05,2026-05-06,2026-07-20,2026-08-11,2026-08-12,2026-08-13,2026-08-14,2026-09-21,2026-09-22,2026-09-23,2026-10-12,2026-11-03,2026-11-23,2026-12-29,2026-12-30,2026-12-31,2027-01-01'.split(',');
	from = new Date('');
	to = new Date('');
	has_shipping = 'true' === 'true';
	sep = '22';
	s = Number('3');
	e = Number('30');
	unavailables = '2025-12-27,2025-12-28,2025-12-29,2025-12-30,2025-12-31,2026-01-01,2026-01-02,2026-01-03,2026-01-04,2026-01-05,2026-01-06'.split(',');

	shippings = [];
	cart = {};
	sync = false;
	leads = [];
	max = 0;

	constructor() {
		fetch('/cart.js')
			.then(r => r.json())
			.then(async r => {
				this.cart = r;
				const { item_count } = this.cart;

				if (item_count === 0) {
					await fetch('/cart/clear.js');
					const attr = {};
					for (const key of Object.keys(this.cart.attributes)) {
						attr[key] = null;
					}
					return await this.update(attr);
				}

				this.sync = document.body.dataset.refresh === 'true';

				const button = document.querySelector('.btn--checkout');
				button.addEventListener('click', async () => {
					button.classList.add('checkout-loading');
					await this.refresh();
					document.querySelector('[name="checkout"]').click();
				});

				this.cart.attributes['お届け希望日'] = this.cart.attributes?.['お届け希望日'] || '指定しない';
				this.cart.attributes['お届け希望時間'] = this.cart.attributes?.['お届け希望時間'] || '指定しない';

				const invoice = document.querySelector('#sendInvoice');
				if (invoice !== null) {
					this.cart.attributes.sendInvoice = this.cart.attributes?.sendInvoice || 0;
					invoice.addEventListener('change', async () => {
						this.cart.attributes.sendInvoice = invoice.value || 0;
						await this.refresh();
					});
				}

				if (2 > item_count && this.cart.attributes?.bundleShipping !== undefined) {
					this.cart.attributes.bundleShipping == null;
				}

				if (item_count > 1) {
					this.cart.attributes.bundleShipping = this.cart.attributes?.bundleShipping || 1;

					const bundle = document.querySelector('#bundleShipping');
					if (bundle !== null) {
						document.querySelector('#shippingContainer').classList.toggle('hide', bundle.value == 1);
						bundle.addEventListener('change', async () => {
							this.cart.attributes.bundleShipping = bundle.value;
							document.querySelector('#shippingContainer').classList.toggle('hide', bundle.value == 1);

							if (bundle.value == 1) {
								this.cart.attributes['お届け希望日'] = '指定しない';
								this.cart.attributes['お届け希望時間'] = '指定しない';
								document.querySelector('#shippingContainer').value = '指定しない';
							}
							await this.refresh();
						});
					}

					const apps = document.querySelectorAll('.app-cc');
					const pullDowns = document.querySelectorAll('.cart-attribute-bundleShipping');
					if (document.querySelector('#cc-delivery-date-time-app') === null) {
						for (const e of [...apps, ...pullDowns]) {
							e.classList.add('hide');
						}
					}

					bundle.addEventListener('change', async () => {
						for (const e of [...apps]) {
							e.classList.toggle('hide', bundle.value !== 0);
						}
					});
				}

				if (this.has_shipping === true) {
					await this.init();
				}

				await this.refresh();
				button.disabled = false;
			});
	};

	calcData = (inventory, normal, order) => {
		if (inventory.management == '') {
			return order;
		}
		if (inventory.policy == 'continue' && inventory.quantity > 0) {
			return normal;
		}
		if (inventory.policy == 'continue' && inventory.quantity <= 0) {
			return order;
		}
		if (inventory.policy == 'deny' && inventory.management == 'shopify' && inventory.quantity > 0) {
			return normal;
		}
		if (inventory.policy == 'deny' && inventory.management == 'shopify' && inventory.quantity <= 0) {
			return { num: '', row: '' };
		}
		return { num: '', row: '' };
	};

	create = (tagname, args, parent = null) => {
		const e = Object.assign(document.createElement(tagname), args);
		if (parent !== null) {
			parent.append(e);
		}
		return e;
	};

	createStart = num => {
		const today = new Date(Date.now() + ((new Date().getTimezoneOffset() + (9 * 60)) * 60 * 1000));
		const disableds = this.disableds.map(e => {
			const index = ['日', '月', '火', '水', '木', '金', '土'].indexOf(e);
			if (index > -1) {
				return index;
			}
		});

		let enabled = [];
		let disabled = [];

		for (const i in [...Array(150)]) {
			const day = new Date(today);
			day.setDate(day.getDate() + Number(i));
			enabled.push(this.date2string(day));
		}

		const from = this.from;
		const to = this.to
		for (let day = from; day <= to; day.setDate(day.getDate() + 1)) {
			disabled.push(this.date2string(day));
		}

		for (const day of this.disable_dates) {
			disabled.push(day);
		}

		if (15 > num) {
			for (const d of enabled) {
				const day = new Date(d);
				if (disableds.includes(day.getDay()) === true) {
					disabled.push(this.date2string(day));
				}
			}
		} else {
			disabled = disabled.filter(day => {
				return disableds.includes(new Date(day).getDay()) === false;
			});
		}

		disabled = disabled.filter(Boolean);
		enabled = enabled.filter(day => disabled.includes(day) === false);

		const start = new Date(enabled[num]);
		if (15 > num && today.getHours() >= this.sep) {
			start.setDate(start.getDate() + 1);
		}

		if (num >= 15) {
			while (disableds.includes(start.getDay()) === true) {
				start.setDate(start.getDate() + 1);
			}
		}

		return start;
	};

	date2string = (date, sep = '-') => {
		return [
			date.getFullYear(),
			(date.getMonth() + 1).toString().padStart(2, '0'),
			date.getDate().toString().padStart(2, '0')
		].join(sep);
	};

	getTerm = () => {
		const start = this.createStart(this.max);

		const s = this.s;
		start.setDate(start.getDate() + s);

		const end = new Date(start);
		const e = this.e;
		end.setDate(end.getDate() + e - s);

		return [start, end];
	};

	init = async () => {
		const shipping2num = {
			'営業日2~3日以内': 3,
			'営業日10日以内': 10,
			'注文から15日以内': 15,
			'注文から20日以内': 20,
			'注文から25日以内': 25,
			'注文から30日以内': 30,
			'注文から35日以内': 35,
			'注文から40日以内': 40,
			'注文から45日以内': 45,
			'注文から50日以内': 50,
			'注文から60日以内': 60,
			'注文から70日以内': 70,
			'注文から80日以内': 80,
			'注文から90日以内': 90,
			'注文から100日以内': 100,
			'注文から120日以内': 120,
		};

		this.shippings = await (await fetch('/cart?view=shipping')).json() || [];
		for (const { normal, order } of this.shippings) {
			normal.num = shipping2num[normal.row] ?? 120;
			order.num = shipping2num[order.row] ?? 120;
		}

		for (const { inventory, normal, order, properties, quantity } of this.shippings) {
			const { num, row } = this.calcData(inventory, normal, order) || [];
			this.leads.push({ num, row, quantity, properties })
			if (num > this.max) {
				this.max = num;
			}
		}

		const [from, to] = this.getTerm();
		const enables = [];
		for (let d = from; d <= to; d.setDate(d.getDate() + 1)) {
			if (!this.unavailables.includes(this.date2string(d))) {
				enables.push(this.date2string(d));
			}
		}

		const datas = document.querySelector('#attributes-shipping-date');
		const times = document.querySelector('#attributes-shipping-date-time');
		if (datas === null && times === null) {
			return;
		}

		this.create('link', { href: 'https://cdn.jsdelivr.net/npm/flatpickr/dist/flatpickr.min.css', rel: 'stylesheet' }, document.head);
		flatpickr(datas, {
			enable: enables,
			dateFormat: 'Ymd',
			locale: 'ja',
			onChange: async (selectedDates, dateStr) => {
				datas.value = dateStr === '' ? '指定しない' : dateStr;
				this.cart.attributes['お届け希望日'] = datas.value;
				await this.refresh();
			},
			onReady: (selectedDates, dateStr, instance) => {
				const button = this.create(
					'button',
					{ className: 'flatpickr-clear', textContent: '指定しない', type: 'button' },
					instance.calendarContainer
				);
				button.addEventListener('click', () => {
					instance.clear();
					instance.close();
					datas.value = '指定しない';
				});
				instance.jumpToDate(new Date(enables[0]));
			}
		});

		times.addEventListener('change', async () => {
			this.cart.attributes['お届け希望時間'] = times.value;
			await this.refresh();
		});

		setInterval(async () => await this.refresh(), 10000);
	};

	refresh = async () => {
		if (this.sync === false) {
			return;
		}

		const [from, to] = this.getTerm();
		const ranges = ['指定しない'];
		for (let d = from; d <= to; d.setDate(d.getDate() + 1)) {
			ranges.push(this.date2string(d, ''));
		}

		if (
			ranges.includes(this.cart.attributes['お届け希望日']) === false
			&& new Date(ranges.reverse()[0]) >= new Date(this.cart.attributes['お届け希望日'])
		) {
			alert('指定できないお届け日が選択されています。再度ご指定ください。');
			this.cart.attributes['お届け希望日'] = '指定しない';
			await this.update();
			return window.location.href = '/cart';
		}

		try {
			const { items } = await (await fetch('/cart.js')).json();

			const requests = Object.entries(this.leads).slice(0, 4).map(async ([_, { properties, num }], i) => {
				const item = items[i];

				if (this.cart.attributes?.bundleShipping == 1) {
					const start = this.createStart(num);
					start.setDate(start.getDate() + 2);
					if (this.cart.attributes['お届け希望日'] == '指定しない') {
						properties['_客先到着予定日'] = this.date2string(start, '');
					} else {
						properties['_客先到着予定日'] = this.cart.attributes['お届け希望日'];
					}
				} else {
					if (this.cart.attributes['お届け希望日'] == '指定しない') {
						const start = this.createStart(this.max);
						start.setDate(start.getDate() + 2);
						properties['_客先到着予定日'] = this.date2string(start, '');
					} else {
						properties['_客先到着予定日'] = this.cart.attributes['お届け希望日'];
					}
				}

				await (await fetch('/cart/change.js', {
					method: 'POST',
					headers: { 'Content-Type': 'application/json' },
					body: JSON.stringify({ line: i + 1, properties: { ...item.properties, ...properties } })
				})).json();
			});
			const res = await Promise.all(requests);

			if (this.leads.length > 4) {
				window.alert('カート情報の更新に失敗しました。\nページを更新し再度お試しください。');
			}

			await this.update();
			return res;
		} catch (err) {
			console.error(0, err);
		}
	};

	update = async (attr = null) => {
		const attributes = attr || this.cart.attributes;
		this.cart = await (await fetch('/cart/update.js', {
			method: 'post',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ attributes })
		})).json();
		return;
	};
};

class collectionSlider {
	constructor() {
		const target = document.querySelector('.collection__dynamic-part');
		if (target === null) {
			return;
		}

		const options = { childList: true, subtree: true };
		const o = new MutationObserver(() => {
			o.disconnect();
			for (const e of target.querySelectorAll('.product-grid-item--container')) {
				this.createSwiper(e);
			}
			o.observe(target, options);
		});
		o.observe(target, options);
	};

	createSwiper(e) {
		if (e?.swiper !== undefined) {
			return;
		}
		e.swiper = new Swiper(e, {
			scrollbar: {
				el: '.product-grid-item--scrollbar',
				draggable: true
			},
			slideClass: 'product-grid-item--slider',
			wrapperClass: 'product-grid-item--wrapper'
		});
	};
};
document.addEventListener('DOMContentLoaded', () => {
	window.collectionSlider = new collectionSlider;
});

const toggleCollectionContent = sid => {
	let current = location.href;

	const section = document.querySelector(`[id*="${sid}"]`);
	const toggleContent = () => {
		const p = new URL(current).searchParams.get('page') || 1;
		if (p > 1) {
			section.classList.add('hide');
			return;
		}
		section.classList.remove('hide');
	};

	toggleContent();

	setInterval(() => {
		if (current !== location.href) {
			current = location.href;
			setTimeout(toggleContent, 2000);
		}
	}, 300);
};

document.addEventListener('DOMContentLoaded', () => {
	const setScroll = () => {
		for (const link of document.querySelectorAll('[href^="#"]:not([href="#"]:not(.sinit)')) {
			link.classList.add('sinit');
			link.addEventListener('click', e => {
				e.preventDefault();
				e.stopPropagation();

				const { hash } = new URL(link.href);
				const header = document.querySelector('[data-section-type="header"]');
				const offset = document.querySelector(hash).getBoundingClientRect().top + window.scrollY;
				scroll({ top: offset - header.offsetHeight - 10, behavior: 'smooth' });
			});
		}
	};

	setScroll();

	let t = 0
	const timer = setInterval(() => {
		t += 100;
		if (window?.PAGEFLY !== undefined || t > 10000) {
			clearInterval(timer);
			setScroll();
		}
	}, 100);
});